import { createContext } from 'react';

type DrawerContextType = {
  open: VoidFunction;
  close: VoidFunction;
};

export const DrawerContext = createContext<DrawerContextType | null>(null);
